<!--嵌入式互联网场次-->
<template>
  <div>
    <ChildrenPage
      :id="1"
      :imgs="[
    require('../assets/imgs/1-1.png'),
    require('../assets/imgs/1-2.png'),
    require('../assets/imgs/1-3.png')
    ]"
    />
  </div>
</template>

<script>
import ChildrenPage from "../components/ChildrenPage";
export default {
  components: {
    ChildrenPage
  },
  filters: {},
  watch: {},
  computed: {},
  data() {
    return {};
  },
  methods: {},
  async created() {},
  mounted() {
      window.scrollTo(0, 0);
  },
  updated() {
    // if (this.setFontSize) {
    //   this.bigSize();
    // }
  },
  beforeDestroy: function() {},
  destroyed() {}
};
</script>


    <!-- <div class="eiot">
        <div class="eiot_banner">
            <img src="../assets/imgs/linshi_banner.png" alt="">
        </div> -->
<!--        <div class="eiot_kv">-->
<!--            <p></p>-->
<!--            <p></p>-->
<!--            <div class="eiot_kv_wrap">-->
<!--                <div class="item">-->
<!--                    <p></p>-->
<!--                    <p></p>-->
<!--                </div>-->
<!--                <div class="item">-->
<!--                    <p></p>-->
<!--                    <p></p>-->
<!--                </div>-->
<!--                <div class="item">-->
<!--                    <p></p>-->
<!--                    <p></p>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <!-- <div class="activesub">
            <img src="../assets/imgs/kv.jpg"  alt="">
        </div>
        <div class="active">
            <img src="../assets/imgs/QRS_pre.png"  alt="">
        </div>
        <div class="Footer">
            <div class="title">抢先了解AIoT解决方案</div>
            <div class="Footer_wrp">
                <a class="Footer_item" target="_blank" href="https://www.advantech.com.cn/solutions/iot-edge-intelligence-solutions-and-services?utm_source=CorpSiteHomepage-InPage&utm_medium=link&utm_campaign=CorpSiteHomepage-SolutionsClicks
">
                    <img src="../assets/imgs/tuyi.png" alt="">
                    <div class="Footer_item_bottom">
                        <span>边缘到云解决方案</span>
                        <img class="arrow" src="../assets/imgs/arrow.png" alt="">
                    </div>
                </a>
                <a class="Footer_item" target="_blank" href="http://select.advantech.com.cn/edge-ai-solutions/
">
                    <img src="../assets/imgs/tuer.png" alt="">
                    <div class="Footer_item_bottom">
                        <span>边缘赋能人工智能</span>
                        <img class="arrow" src="../assets/imgs/arrow.png" alt="">
                    </div>
                </a>
                <a class="Footer_item" target="_blank" href="https://www.advantech.com.cn/solutions/embedded-modules-and-design-in-services?utm_source=CorpSiteHomepage-InPage&utm_medium=link&utm_campaign=CorpSiteHomepage-SolutionsClicks">
                    <img src="../assets/imgs/tusan.png" alt="">
                    <div class="Footer_item_bottom">
                        <span>嵌入式设计服务</span>
                        <img class="arrow" src="../assets/imgs/arrow.png" alt="">
                    </div>
                </a>
                <a class="Footer_item" target="_blank" href="https://www.advantech.com.cn/solutions/design-and-manufacturing-services?utm_source=CorpSiteHomepage-InPage&utm_medium=link&utm_campaign=CorpSiteHomepage-SolutionsClicks
">
                    <img src="../assets/imgs/tusi.png" alt="">
                    <div class="Footer_item_bottom">
                        <span>客制化服务</span>
                        <img class="arrow" src="../assets/imgs/arrow.png" alt="">
                    </div>
                </a>
            </div>
        </div>

        <div class="Bottom">
            <img src="../assets/imgs/bottom.png"  alt="">
        </div>
    </div> -->

<style lang="less" scoped>
// .eiot {
//   .eiot_banner {
//     position: relative;
//     img {
//       width: 100vw;
//     }
//   }
//   .eiot_kv {
//     /*height: 350px;*/
//     /*background: url("../assets/imgs/kv.png") no-repeat;*/
//     /*background-size: 100vw auto;*/
//   }
//   .activesub {
//     margin-top: -78px;
//     img {
//       width: 100vw;
//     }
//   }
//   .active {
//     width: 100vw;
//     margin: 0 auto;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     img {
//       margin-left: 20px;
//       margin-top: 80px;
//       width: 1080px;
//     }
//   }
//   .Footer {
//     width: 1000px;
//     margin: 100px auto 100px;
//     text-align: center;
//     padding: 50px;
//     background-color: rgb(236, 242, 247);
//     .title {
//       margin-bottom: 50px;
//       font-size: 28px;
//       font-weight: bold;
//     }
//     .Footer_wrp {
//       display: flex;
//       justify-content: space-between;
//     }
//     .Footer_item {
//       position: relative;
//       img {
//         width: 220px;
//       }
//       .Footer_item_bottom {
//         position: absolute;
//         bottom: 0;
//         left: 0;
//         right: 0;
//         display: flex;
//         margin-bottom: 5px;
//         align-items: center;
//         span {
//           font-size: 22px;
//           color: #ffffff;
//           margin-left: 10px;
//         }
//         img {
//           margin-left: auto;
//           margin-right: 10px;
//           flex-shrink: 0;
//           height: 15px;
//           width: 10px;
//         }
//       }
//     }
//   }
//   .Bottom {
//     img {
//       width: 100vw;
//     }
//   }
// }
</style>
